import LayersIcon from '@mui/icons-material/Layers';
import CoffeeIcon from '@mui/icons-material/Coffee';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import HubIcon from '@mui/icons-material/Hub';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import {
  FullStackCurriculumData,
  JavaFullStackCurriculumData,
  DSACurriculumData,
  SystemDesignCurriculumData,
  AgenticAICurriculumData
} from '../components/CurriculumData';

export const courses = [
  {
    featured: true,
    level: 'Beginner → Advanced',
    title: 'Full-Stack Web Development',
    tagline: 'MERN Stack',
    description: 'One complete path from your first HTML tag to a deployed production app. Master the frontend, backend, database and tooling that modern teams ship with.',
    duration: '6 months',
    curriculumData: FullStackCurriculumData,
    icon: LayersIcon,
    accent: ['#22d3ee', '#a855f7'],
    stack: [
      { name: 'HTML', logo: 'https://upload.wikimedia.org/wikipedia/commons/3/38/HTML5_Badge.svg' },
      { name: 'CSS', logo: 'https://upload.wikimedia.org/wikipedia/commons/6/62/CSS3_logo.svg' },
      { name: 'JavaScript', logo: 'https://upload.wikimedia.org/wikipedia/commons/9/99/Unofficial_JavaScript_logo_2.svg' },
      { name: 'React', logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg' },
      { name: 'Node.js', logo: 'https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg' },
      { name: 'MongoDB', logo: 'https://upload.wikimedia.org/wikipedia/commons/9/93/MongoDB_Logo.svg' },
      { name: 'Git', logo: 'https://upload.wikimedia.org/wikipedia/commons/3/3f/Git_icon.svg' }
    ]
  },
  {
    level: 'Beginner → Advanced',
    title: 'Java Full-Stack',
    description: 'Core Java, Spring Boot, JPA, Spring Security and React — build enterprise-grade applications end to end.',
    duration: '6 months',
    curriculumData: JavaFullStackCurriculumData,
    icon: CoffeeIcon,
    accent: ['#f97316', '#ef4444'],
    tags: ['Java', 'Spring Boot', 'SQL', 'React']
  },
  {
    level: 'All Levels',
    title: 'Data Structures & Algorithms',
    description: 'Pattern-based problem solving that cracks coding interviews — from arrays and trees to graphs and dynamic programming.',
    duration: '4 months',
    curriculumData: DSACurriculumData,
    icon: AccountTreeIcon,
    accent: ['#4ade80', '#14b8a6'],
    tags: ['Big-O', 'Graphs', 'DP', 'Interview Prep']
  },
  {
    level: 'Intermediate',
    title: 'System Design',
    description: 'Design scalable, reliable systems. Learn caching, sharding, queues and walk through real-world case studies.',
    duration: '3 months',
    curriculumData: SystemDesignCurriculumData,
    icon: HubIcon,
    accent: ['#60a5fa', '#6366f1'],
    tags: ['HLD', 'LLD', 'Scalability', 'Case Studies']
  },
  {
    level: 'Intermediate',
    title: 'Agentic AI',
    description: 'Build AI agents that reason, use tools and take action — with LLMs, RAG, MCP, multi-agent systems and evals.',
    duration: '3 months',
    curriculumData: AgenticAICurriculumData,
    icon: SmartToyIcon,
    accent: ['#f472b6', '#a855f7'],
    tags: ['LLMs', 'RAG', 'Tool Use', 'Multi-Agent'],
    isNew: true
  }
];
